'use client';
import type { ReactNode } from 'react';

type CouponErrorProps = {
  message?: string;
};

/**
 * Test component for coupon error handling.
 *
 * @param root0 props for coupon error
 * @param root0.message Error message to display
 * @returns Fallback component for coupon errors
 */
export function CouponError({ message }: CouponErrorProps): ReactNode {
  return (
    <div className="text-red-500">
      {message ?? 'Hoppsan, något gick fel när omgångarna skulle laddas. Försök igen senare.'}
    </div>
  );
}
